import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { $notificationStore } from '../notificationStore';
import { TransferRequestsApi } from '@shared/api/rest';
import type { TransferRequestCreateDocumentRequest } from '@shared/api/rest/transferRequests';

const effect = createEffect((request: TransferRequestCreateDocumentRequest) => TransferRequestsApi.createDocument(request));
const clearEvent = createEvent();

const $dataStore = createStore<string>('')
  .on(effect.done, (_, values) => values.result.data)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(effect.pending, (_, data) => data)
  .on(effect.fail, () => false)
  .on(effect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(effect, () => null)
  .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(effect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((x) => $notificationStore.events.setError(x));

export const $transferRequestsUploadFileStore = {
  events: {
    update: effect,
    clear: clearEvent,
  },
  store: combine({
    data: $dataStore,
    loading: $loadingStore,
    error: $errorStore,
  }),
};
